import { BoxStaffDetailedEntity } from "@modules/boxStaff/entities/boxStaffEntity"
import { word } from "@modules/core/utils/i18n"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { HUText } from "@modules/ui/components/huText"
import { Dumbbell, Mail } from "lucide-react"
import { Skeleton } from "primereact/skeleton"
import { useTheme } from "styled-components"

type Props = {
  staffDetailed?: BoxStaffDetailedEntity | null
} & React.HTMLAttributes<HTMLDivElement>
export const BoxStaffTabProfile: React.FC<Props> = ({ staffDetailed, ...props }) => {
  const theme = useTheme()

  // SKELETON
  if (!staffDetailed) {
    return (
      <div className="flex flex-column w-full gap-6" {...props}>
        {/* CONTACT */}
        <div className="flex flex-column mt-2 gap-3">
          <HUText fontStyle="TM" color={theme.mainWhite}>
            {word("box.member.table.profile.contact")}
          </HUText>
          <div className="flex">
            <div className="flex flex-1 gap-2 align-items-center">
              <Mail strokeWidth="1" />
              <Skeleton width="12rem" borderRadius="4px" />
            </div>
          </div>

          <div className="flex flex-row gap-2">
            <Dumbbell strokeWidth="1" />
            <div className="flex flex-column gap-1">
              <HUText className="uppercase" fontStyle="BS" color={theme.neutralColor600}>
                {word("box.member.table.profile.startDate")}
              </HUText>
              <Skeleton width="5.5rem" borderRadius="4px" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-column w-full gap-6" {...props}>
      {/* CONTACT */}
      <div className="flex flex-column mt-2 gap-3">
        <HUText fontStyle="TM" color={theme.mainWhite}>
          {word("box.member.table.profile.contact")}
        </HUText>
        <div className="flex">
          <div className="flex flex-1 gap-2">
            <Mail strokeWidth="1" />
            <HUText fontStyle="TS" color={theme.mainWhite}>
              {staffDetailed.email}
            </HUText>
          </div>
        </div>
      </div>
      {staffDetailed.publicProfile && <PublicProfileDetails publicProfile={staffDetailed.publicProfile} />}
    </div>
  )
}
